module.exports = __webpack_public_path__ + "static/investments-hero-mobile.b3888967.webp";